import React, { FC } from 'react'
import SimpleSwitch from 'src/components/ui/SimpleSwitch'

interface ISimpleLabeledSwitchProps {
  isEnabled: boolean
  onChange: () => any
  leftLabel: string
  rightLabel: string
  className?: string
  isGrayBackground?: boolean
  noPadding?: boolean
}

const SimpleLabeledSwitch: FC<ISimpleLabeledSwitchProps> = ({
  leftLabel,
  rightLabel,
  onChange,
  isEnabled,
  className,
  isGrayBackground,
  noPadding,
}) => (
  <>
    <div
      className={`flex items-center justify-start
        ${noPadding ? '' : 'py-2'}
        ${className}`}
    >
      <button
        type="button"
        onClick={() => (isEnabled ? onChange() : () => {})}
        className={`${
          !isEnabled
            ? 'text-appGreen font-bold cursor-default'
            : 'text-white cursor-pointer'
        } uppercase text-lg sm:text-xl lg:text-base leading-none`}
      >
        {leftLabel}
      </button>
      <div className="leading-none">
        <SimpleSwitch
          onChange={onChange}
          isEnabled={isEnabled}
          className="mx-4"
          isGrayBackground={isGrayBackground}
        />
      </div>
      <button
        type="button"
        onClick={() => (!isEnabled ? onChange() : () => {})}
        className={`${
          isEnabled
            ? 'text-appGreen font-bold cursor-default'
            : 'text-white cursor-pointer'
        } uppercase text-lg sm:text-xl lg:text-base leading-none`}
      >
        {rightLabel}
      </button>
    </div>
  </>
)

export default SimpleLabeledSwitch
